"use strict";
/**
 * @Author Perch.Voskerchyan
 * @Date 13.03.2018
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
/**
 * This component provides the functionality and styles of loading bar.
 * The component should be used when the activated router is changed or app loads some data.
 */
require("./sis-progress-spinner.component.css");
var ProgressSpinnerComponent = /** @class */ (function () {
    function ProgressSpinnerComponent() {
        /**
         * Theme color palette for the Spinner.
         * available values: primary, accent, warn
         * @type {string}
         * @default primary
         */
        this.color = "primary";
        /**
         * Mode of the progress circle.
         * Can be determinate or indeterminate
         * @type {boolean}
         * @default false
         */
        this.isAnimated = false;
        /**
         * Value of the progress circle.
         * If the mode of the progress circle is determinate, the {percent} should has a value from 1 to 100
         * @type {number}
         * @default 80
         */
        this.percent = 80;
        /**
         * Stroke width of the progress spinner.
         * Recommended value is {diameter} * 10
         * @type {number}
         * @default 100
         */
        this.strokeWidth = 40;
        /**
         * The diameter of the progress spinner (will set width and height of svg).
         * Recommended value is {strokeWidth} / 10
         * @type {number}
         * @default 10
         */
        this.diameter = 4;
        /**
         * Loading text for the progress spinner.
         * Progress spinner can have the loading text.
         * @type {boolean}
         * @default true
         */
        this.hasText = true;
        /**
         * Position of loading text.
         * can be beside or below
         * @type {boolean}
         * @default true
         */
        this.isTextBeside = true;
    }
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], ProgressSpinnerComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], ProgressSpinnerComponent.prototype, "color", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], ProgressSpinnerComponent.prototype, "isAnimated", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], ProgressSpinnerComponent.prototype, "percent", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], ProgressSpinnerComponent.prototype, "strokeWidth", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], ProgressSpinnerComponent.prototype, "diameter", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], ProgressSpinnerComponent.prototype, "hasText", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], ProgressSpinnerComponent.prototype, "isTextBeside", void 0);
    ProgressSpinnerComponent = __decorate([
        core_1.Component({
            
            selector: "sis-progress-spinner",
            template: require('./sis-progress-spinner.component.html'),
        })
    ], ProgressSpinnerComponent);
    return ProgressSpinnerComponent;
}());
exports.ProgressSpinnerComponent = ProgressSpinnerComponent;
//# sourceMappingURL=sis-progress-spinner.component.js.map